import { Chance } from "chance"
import { DictionarySupplier } from "etl/types";

const chance = new Chance();

export const dictionarySupplierFactoryMock = (howMany: number): DictionarySupplier[] =>
	Array.from({ length: howMany }).map((_, index) => ({
		"@id": `/dictionary_suppliers/${index + 1}`,
		"@type": "DictionarySupplier",
		id: index + 1,
		libelle: chance.word(),
		hb_supplier_id: chance.integer().toString(),
		hb_supplier_libelle: chance.word(),
	}));
